<template>
	<v-footer color="primary" :absolute="absolute">
		<v-col>
			<v-row no-gutters align="center">
				<!-- <img
					style="max-height: 23px"
					src="https://www.easypay.pt/static/img/5.656e359.png"
				/> -->
				<v-spacer></v-spacer>
				<v-btn dark icon small href="https://www.naltio.com" target="_blank">
          <v-icon size="20px">mdi-home-circle</v-icon>
        </v-btn>
				<v-btn class="mx-4" dark icon small href="https://www.facebook.com/naltioapp" target="_blank">
          <v-icon size="20px">mdi-facebook</v-icon>
        </v-btn>
				<v-btn class="mr-4" dark icon small href="https://www.youtube.com/channel/UCrYXUAvLp-MtKQvhmG77AiA" target="_blank">
          <v-icon size="20px">mdi-youtube</v-icon>
        </v-btn>
				<span class="white--text text-subtitle-2 font-weight-bold">Naltio © {{ new Date().getFullYear() }}</span>
			</v-row>
		</v-col>
	</v-footer>
</template>

<script>
export default {
	name: "Footer",
	props: {
		absolute: {
			default: false
		}
	}
};
</script>